module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    staticClass: "bodyPadding",
    attrs: {
      "id": "inspire"
    }
  }, [_c('mo-header'), _vm._v(" "), _c('v-content', [_c('process-head'), _vm._v(" "), _c('process-list')], 1)], 1)
},staticRenderFns: []}